<template>


  <section class="mt-5 sm-max:px-6 font-ww-medium">



    <div class="w-full px-3">
      <h2 class="max-w-screen-md mx-auto mt-6 mb-4 text-center h2"><strong>{{ titleBold }}</strong> {{titleItalic}} </h2>
    </div>




    <div class="flex flex-wrap overflow-hidden ">
      <div class="p-1.5 w-1/3 md:w-1/6 overflow-hidden" v-for="image in images">
        <nuxt-img
            :key="image.alt"
            class="w-full"
            loading="lazy"
            width="300"
            height="435"
            sizes="xs:95px sm:140px md:243px lg:157px xl:187px 2xl:300px"
            format="webp"
            :alt="image.alt"
            :src="image.src"
        />
      </div>


    </div>

  </section>

</template>



<script setup>

const props = defineProps({
  titleBold: {
    type: String,
    default: 'People All Over the USA'
  },
  titleItalic: {
    type: String,
    default: 'Loving This Coffee',
  },
  images: {
    type: Array,
    default: () => [
      { src: "/person-1.jpg", alt: "person-1" },
      { src: "/person-2.jpg", alt: "person-2" },
      { src: "/person-3.jpg", alt: "person-3" },
      { src: "/person-4.jpg", alt: "person-4" },
      { src: "/person-5.jpg", alt: "person-5" },
      { src: "/person-6.jpg", alt: "person-6" },
      { src: "/person-7.jpg", alt: "person-7" },
      { src: "/person-8.jpg", alt: "person-8" },
      { src: "/person-9.jpg", alt: "person-9" },
      { src: "/person-10.jpg", alt: "person-10" },
      { src: "/person-11.jpg", alt: "person-11" },
      { src: "/person-12.jpg", alt: "person-12" }
    ],
  },
})

defineBuilderComponent({
    friendlyName: "AllPeople2",
    canHaveChildren: true,
    inputs: [
        {
            name: "titleBold",
            type: "text",
            defaultValue: "People All Over the USA"
        },
        {
            name: "titleItalic",
            type: "text",
            defaultValue: "Loving This Coffee"
        },
        {
            name: "images",
            type: "list",
            subFields: [
                {
                    name: "src",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "svg",
                        "png"
                    ],
                    required: true
                },
                {
                    name: "alt",
                    type: "text",
                    required: true
                }
            ],
            defaultValue: [
                {
                    src: "/person-1.jpg",
                    alt: "person-1"
                },
                {
                    src: "/person-2.jpg",
                    alt: "person-2"
                },
                {
                    src: "/person-3.jpg",
                    alt: "person-3"
                },
                {
                    src: "/person-4.jpg",
                    alt: "person-4"
                },
                {
                    src: "/person-5.jpg",
                    alt: "person-5"
                },
                {
                    src: "/person-6.jpg",
                    alt: "person-6"
                },
                {
                    src: "/person-7.jpg",
                    alt: "person-7"
                },
                {
                    src: "/person-8.jpg",
                    alt: "person-8"
                },
                {
                    src: "/person-9.jpg",
                    alt: "person-9"
                },
                {
                    src: "/person-10.jpg",
                    alt: "person-10"
                },
                {
                    src: "/person-11.jpg",
                    alt: "person-11"
                },
                {
                    src: "/person-12.jpg",
                    alt: "person-12"
                }
            ]
        }
    ]
});
</script>